import React from "react";
import GoogleSigning from "../../components/GoogleSigning"


function Index() {
  return (
      <GoogleSigning type="error"  text={`An error occurred during the sign-in process. Please attempt signing in again later.`} />
  );
}

export default Index;
